import { useCallback, useEffect, useState } from "react";
import { NavLink, Outlet, useParams, Link, Navigate, useLocation } from "react-router-dom";
import { Broadcast } from "@phosphor-icons/react";
import { useApi } from "../../lib/api";
import { GROUP_TYPES } from "../../lib/constants";

const Tab = ({ to, label, testid, end }) => (
  <NavLink to={to} end={end} data-testid={testid}
    className={({ isActive }) => `px-4 py-2 text-sm border-b-2 transition-colors whitespace-nowrap ${isActive ? "text-white" : "border-transparent text-slate-400 hover:text-white"}`}
    style={({ isActive }) => (isActive ? { borderColor: "var(--group)" } : {})}>{label}</NavLink>
);

export default function GroupLayout() {
  const { gid } = useParams();
  const api = useApi();
  const loc = useLocation();
  const [group, setGroup] = useState(null);
  const [error, setError] = useState(false);
  const reload = useCallback(() => api.get(`/groups/${gid}`).then((r) => setGroup(r.data)).catch(() => setError(true)), [api, gid]);
  useEffect(() => { setGroup(null); reload(); }, [reload]);
  if (error) return <div className="text-slate-400" data-testid="group-not-found">Group not found.</div>;
  if (!group) return <div className="text-slate-400">Loading…</div>;
  const t = GROUP_TYPES[group.type];
  const r = group.my_role;
  const admin = r === "admin" || r === "super";
  const home = { nurse: "nurse", front_desk: "attendance" }[r];
  if (home && !loc.pathname.endsWith(`/${home}`)) return <Navigate to={`/app/g/${gid}/${home}`} replace />;
  return (
    <div style={{ "--group": t.color }} data-testid="group-layout">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-2">
        <div className="overline" style={{ color: t.color }} data-testid="group-type-label">{t.label} · {group.country} · {group.currency}{!admin && ` · ${{ nurse: "Medical staff", front_desk: "Front desk", viewer: "Viewer" }[r]}`}</div>
        {r !== "viewer" && <Link to={`/reader/${gid}`} data-testid="open-reader-station-btn" className="inline-flex items-center gap-2 text-xs rounded-full border border-slate-600 px-3 py-1.5 hover:border-slate-400 transition-colors"><Broadcast size={14} />Reader station</Link>}
      </div>
      <div className="flex overflow-x-auto border-b border-slate-800 mb-8 -mx-1">
        {(admin || r === "viewer") && <><Tab to="" end label="Overview" testid="tab-dashboard" />
          <Tab to="tags" label="Tags & QR" testid="tab-tags" />
          <Tab to="orders" label="Orders & invoices" testid="tab-orders" />
          <Tab to="scans" label="Scan log" testid="tab-scans" /></>}
        {admin && <Tab to="attendance" label="Attendance" testid="tab-attendance-admin" />}
        {admin && <><Tab to="team" label="Admins & roles" testid="tab-team" />
          <Tab to="settings" label="Settings" testid="tab-settings" /></>}
        {r === "nurse" && <Tab to="nurse" label="Nurse view" testid="tab-nurse" />}
        {r === "front_desk" && <Tab to="attendance" label="Attendance" testid="tab-attendance" />}
      </div>
      <Outlet context={{ group, labels: t, reload }} />
    </div>
  );
}
